// CacheKey b5963af91ecab50b620b7eae556cd129
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
// Uses standard ES imports (not import-fresh) for Node.js 24+ compatibility.
import merge from 'lodash/merge'

import ar from './ar'
import coreEnAccountStrategy from './core.en-ACCOUNT_STRATEGY'
import dataViewEnAccountStrategy from './data_view.en-ACCOUNT_STRATEGY'
import searchEnAccountStrategy from './search.en-ACCOUNT_STRATEGY'
import simpleFormEnAccountStrategy from './simple_form.en-ACCOUNT_STRATEGY'
import coreEnArchCare from './core.en-ARCH_CARE'
import dataViewsEnArchCare from './data_views.en-ARCH_CARE'
import enArchCare from './en-ARCH_CARE'
import searchEnArchCare from './search.en-ARCH_CARE'
import simpleFormEnArchCare from './simple_form.en-ARCH_CARE'
import coreEnAscent from './core.en-ASCENT'
import dataViewEnAscent from './data_view.en-ASCENT'
import searchEnAscent from './search.en-ASCENT'
import simpleFormEnAscent from './simple_form.en-ASCENT'
import simpleFormEnCedarCommunity from './simple_form.en-CEDAR_COMMUNITY'
import searchEnCommunityHospital from './search.en-COMMUNITY_HOSPITAL'
import coreEnDictionaryTestProvider from './core.en-DICTIONARY_TEST_PROVIDER'
import dataViewsEnDictionaryTestProvider from './data_views.en-DICTIONARY_TEST_PROVIDER'
import simpleFormEnDictionaryTestProvider from './simple_form.en-DICTIONARY_TEST_PROVIDER'
import simpleFormEnIntermountain from './simple_form.en-INTERMOUNTAIN'
import coreEnJackHughston from './core.en-JACK_HUGHSTON'
import dataViewEnJackHughston from './data_view.en-JACK_HUGHSTON'
import searchEnJackHughston from './search.en-JACK_HUGHSTON'
import simpleFormEnJackHughston from './simple_form.en-JACK_HUGHSTON'
import coreEnLhc from './core.en-LHC'
import dataViewEnLhc from './data_view.en-LHC'
import searchEnLhc from './search.en-LHC'
import simpleFormEnLhc from './simple_form.en-LHC'
import coreEnNcqa from './core.en-NCQA'
import dataViewEnNcqa from './data_view.en-NCQA'
import simpleFormEnNcqa from './simple_form.en-NCQA'
import coreEnPayer from './core.en-PAYER'
import dataViewEnPayer from './data_view.en-PAYER'
import searchEnPayer from './search.en-PAYER'
import simpleFormEnPayer from './simple_form.en-PAYER'
import coreEnSuffolkCareCollaborative from './core.en-SUFFOLK_CARE_COLLABORATIVE'
import dataViewEnSuffolkCareCollaborative from './data_view.en-SUFFOLK_CARE_COLLABORATIVE'
import searchEnSuffolkCareCollaborative from './search.en-SUFFOLK_CARE_COLLABORATIVE'
import simpleFormEnSuffolkCareCollaborative from './simple_form.en-SUFFOLK_CARE_COLLABORATIVE'
import coreEnUcsfMedicalCenter from './core.en-UCSF_MEDICAL_CENTER'
import dataViewEnUcsfMedicalCenter from './data_view.en-UCSF_MEDICAL_CENTER'
import simpleFormEnUcsfMedicalCenter from './simple_form.en-UCSF_MEDICAL_CENTER'
import coreEn from './core.en'
import coreEs from './core.es'
import dataViewEn from './data_view.en'
import deviseEn from './devise.en'
import dynamicServicesEn from './dynamic_services.en'
import en from './en'
import es from './es'
import exceptionsEn from './exceptions.en'
import id from './id'
import ko from './ko'
import mr from './mr'
import nl from './nl'
import pl from './pl'
import protipsEn from './protips.en'
import ro from './ro'
import rulesEn from './rules.en'
import searchEn from './search.en'
import simpleFormEn from './simple_form.en'
import tr from './tr'
import uk from './uk'
import zh from './zh'

export default merge({},
  ar,
  coreEnAccountStrategy,
  dataViewEnAccountStrategy,
  searchEnAccountStrategy,
  simpleFormEnAccountStrategy,
  coreEnArchCare,
  dataViewsEnArchCare,
  enArchCare,
  searchEnArchCare,
  simpleFormEnArchCare,
  coreEnAscent,
  dataViewEnAscent,
  searchEnAscent,
  simpleFormEnAscent,
  simpleFormEnCedarCommunity,
  searchEnCommunityHospital,
  coreEnDictionaryTestProvider,
  dataViewsEnDictionaryTestProvider,
  simpleFormEnDictionaryTestProvider,
  simpleFormEnIntermountain,
  coreEnJackHughston,
  dataViewEnJackHughston,
  searchEnJackHughston,
  simpleFormEnJackHughston,
  coreEnLhc,
  dataViewEnLhc,
  searchEnLhc,
  simpleFormEnLhc,
  coreEnNcqa,
  dataViewEnNcqa,
  simpleFormEnNcqa,
  coreEnPayer,
  dataViewEnPayer,
  searchEnPayer,
  simpleFormEnPayer,
  coreEnSuffolkCareCollaborative,
  dataViewEnSuffolkCareCollaborative,
  searchEnSuffolkCareCollaborative,
  simpleFormEnSuffolkCareCollaborative,
  coreEnUcsfMedicalCenter,
  dataViewEnUcsfMedicalCenter,
  simpleFormEnUcsfMedicalCenter,
  coreEn,
  coreEs,
  dataViewEn,
  deviseEn,
  dynamicServicesEn,
  en,
  es,
  exceptionsEn,
  id,
  ko,
  mr,
  nl,
  pl,
  protipsEn,
  ro,
  rulesEn,
  searchEn,
  simpleFormEn,
  tr,
  uk,
  zh,
)

